import { Color24, Colors24 } from '@grammarly/badger-ui'

interface WebinarProps {
  color?: Color24
}

export const PieGraphIcon = (props: WebinarProps) => {
  const { color = 'green60' } = props
  const strokeColor = Colors24[color]
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.16667 1.54492C4.41671 1.95946 1.5 5.13869 1.5 8.99915C1.5 13.1413 4.85786 16.4991 9 16.4991C12.8605 16.4991 16.0397 13.5824 16.4542 9.83248H8.16667V1.54492Z"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0732 6.49915H11.5V1.92606C13.631 2.67926 15.3199 4.36819 16.0732 6.49915Z"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
